var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LayoutColumn",
    [
      _c("SectionTitle", [
        _vm._v(" " + _vm._s(_vm.$t("Search.labels.databaseTitle")) + " "),
      ]),
      _c(
        "SectionBlock",
        { staticClass: "row-space" },
        [
          _c(
            "LayoutContainer",
            [
              _c(
                "LayoutColumn",
                [_c("SequenceTypeField", { staticClass: "mb0" })],
                1
              ),
              _c(
                "LayoutColumn",
                [
                  _c("DBTypeField", {
                    staticClass: "mb0",
                    attrs: { multiple: _vm.multiple },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isSlowSearch
            ? _c(
                "div",
                { staticClass: "slow-warning" },
                [
                  _c("PtIcon", { attrs: { icon: "SolidWarning" } }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("Search.propver.Preferences.slowWarning"))
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }